var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_858318",
    "data-name": "Path 858318",
    d: "M27.72,32.95V33h.03Z",
    transform: "translate(23.114 27.487)",
    fill: "#356f92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858321",
    "data-name": "Path 858321",
    d: "M44,4.5A39.5,39.5,0,1,0,83.5,44,39.551,39.551,0,0,0,44,4.5Zm0,63.808c-4.274,0-7.6-1.945-7.6-6.077H51.6C51.535,66.282,48.234,68.308,44,68.308Zm21.269-9.115H22.731V53.885l5.327-6.847V40.9c0-7.677,3-14.3,10.635-16l.749-5.206h9.115l.77,5.206c7.6,1.7,10.635,8.366,10.635,16v6.138l5.307,6.847Z",
    fill: "#356f92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858322",
    "data-name": "Path 858322",
    d: "M0,0H88V88H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNotification);
export default __webpack_public_path__ + "static/media/SendNotification.f36fc567e9cf816a22089cf56c4b255c.svg";
export { ForwardRef as ReactComponent };